import React, { useState, useEffect } from 'react';
import MenuAdmin from '../../../components/layout/menu';
import Card from '../../../components/card/index';
import Filtro from '../../../components/filters/filterMenu/index';
import { getVisit } from "../../../client/administration/board/index";
import ContentLoader from 'react-content-loader'; 
import Programate from '../../../components/layout/footer';
import List from '../../../screens/menu/list/visitList/index'; 

const Cards = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);

  const [records, setRecords] = useState([]);
  const [filteredRecords, setFilteredRecords] = useState([]); 
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true); 
  
  const [selectedCompany, setSelectedCompany] = useState("");
  const [plate, setPlate] = useState('');
  const [searchTerm, setSearchTerm] = useState("");

  const [viewMode, setViewMode] = useState('card');
  const toggleViewMode = () => {
    setViewMode(viewMode === 'card' ? 'list' : 'card');
  };
  // Función para obtener los registros (visitas)
  const fetchVisitas = async () => {
    try {
      const { data } = await getVisit();
      setRecords(data); 
      setFilteredRecords(data); 
    } catch (err) {
      setError(err.message || "Error al cargar los productos");
    } finally {
      setLoading(false); // Detener el loading después de obtener los datos
    }
  };

  useEffect(() => {
    fetchVisitas();
  }, []);

  return (
    <div className='flex w-full min-h-screen'>
      <MenuAdmin isMenuOpen={isMenuOpen} toggleMenu={toggleMenu} className="transition-all duration-300" />
      <div className={`flex-1 transition-all duration-300 ml-0 ${isMenuOpen ? "lg:ml-[216px] " : "ml-0"} w-[78%] `}>
        <div className='flex flex-col justify-between w-full min-h-screen'>
          <div className='pb-12 px-[3%]'>
            {loading ? (
              <div className="mt-24 des:mt-24 lg:mt-28 4k:mt-24 2xl:mt-24">
                {/* Skeleton para el título y un rectángulo que ocupa todo el ancho */}
                <ContentLoader
                  viewBox="0 0 1200 500"
                  height="100%"
                  width="100%"
                  backgroundColor="#f3f3f3"
                  foregroundColor="#ecebeb"
                  speed={5}
                >
                  <rect x="2%" y="0" width="31%" height="40" rx="5" ry="5" /> 
                  <rect x="66%" y="0" width="18%" height="40" rx="5" ry="5" /> 
                  <rect x="86%" y="0" width="11%" height="40" rx="5" ry="5" /> 
    
                  {/* columnas de estados*/}
                  <rect x="2%" y="60" width="30%" height="90%" rx="5" ry="5" /> 
                  <rect x="35%" y="60" width="30%" height="90%" rx="5" ry="5" /> 
                  <rect x="67%" y="60" width="30%" height="90%" rx="5" ry="5" /> 
                </ContentLoader>
              </div>
            ) : (
              <>
              <div className='flex items-center justify-end pt-28 '>
                <span className="mr-2 font-itcmedium text-[14px] text-gray">
                  {viewMode === 'card' ? 'Vista de Tarjetas' : 'Vista de Lista'}
                </span>
                <button
                  onClick={toggleViewMode}
                  className={`relative w-12 h-6 rounded-full p-1 transition-colors duration-300 ${
                    viewMode === 'card' ? 'bg-green' : 'bg-gray'
                  } focus:outline-none`} // Agregado focus:outline-none para mejorar accesibilidad
                >
                  <div
                    className={`absolute top-1/2 -translate-y-1/2 w-4 h-4 bg-white rounded-full shadow-md transform transition-transform duration-300 ${
                      viewMode === 'card' ? 'translate-x-6' : 'translate-x-0'
                    }`}
                  ></div>
                </button>
              </div>
           
               {viewMode === 'card' ? (
                
              <div>
                <div className='pt-4'>
                  {/* Pasamos selectedCompany y setSelectedCompany al filtro */}
                  <Filtro 
                    setFilteredRecords={setFilteredRecords} 
                    records={records} 
                    selectedCompany={selectedCompany} 
                    setSelectedCompany={setSelectedCompany} 
                    plate={plate}
                    setPlate={setPlate}
                    searchTerm={searchTerm}
                    setSearchTerm={setSearchTerm}
                  />
                 
                </div>
    
                <div className='mt-4 des:mt-2 4k:mt-3'>
                  <Card 
                    filterCompany={selectedCompany} 
                    filterPlate={plate}
                    filterSearch={searchTerm}
                  />
                </div>
               
              </div>
            ) : (
              <div className=''>
                <List records={filteredRecords} />
              </div>
            )}
              </>
            )}
          </div>
          <Programate/>
        </div>
      </div>
    </div>
  );
};

export default Cards;